import buttonBack from '@/assets/btn/back.png';
import { Sound } from '@/classes';
import { keyCodes } from '@/constants';
import { useExtendFocusable } from '@/hooks/useExtendFocusable';
import { useFocusElement } from '@/hooks/useFocusElement';
import { useRouter } from '@/hooks/useRouter';
import { ContentGroupDetail } from '@/types';
import { useCallback } from 'react';

export type ContentGroupDetailHeaderProps = {
  contentGroup?: ContentGroupDetail;
};

export const ContentGroupDetailHeader = ({ contentGroup }: ContentGroupDetailHeaderProps) => {
  const router = useRouter();
  const { ref, focused } = useExtendFocusable();

  const handleBackClick = useCallback(() => {
    Sound.press();
    router.pop();
  }, [router]);

  useFocusElement({ ref, focused, onClick: handleBackClick, keyCode: keyCodes.ENTER });

  return (
    <div
      className="flex items-center fixed w-full z-40 outline-disable top-0 bg-gray-400"
      style={{
        backgroundImage: `url(${contentGroup?.header?.background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <img
        tabIndex={0}
        ref={ref}
        className="absolute top-[44px] left-[50px] p-[20px] w-[90px] h-[90px] rounded-[20px] outline-disable focus:bg-[#FF66AE] hover:bg-[#FF66AE]"
        src={buttonBack}
        onClick={handleBackClick}
        onContextMenu={handleBackClick}
      />

      <div className="ml-[200px] flex my-[28px] w-full">
        <img
          src={contentGroup?.header?.icon}
          className="rounded-full h-[124px] w-[124px] border-4 border-white bg-gray-600"
        />

        <div className="flex flex-col justify-center ml-[25px]">
          <h1 className="text-[42px] text-black font-bold">{contentGroup?.header?.title}</h1>
        </div>
      </div>
    </div>
  );
};
